// 261015 P5a (D7/C47) — bấm "Đẩy sang Chapters…": GET kế hoạch → `handoffClickDecision` → toast (không việc) / đẩy thẳng (không rò) / mở hộp (có tên gốc rò).
// Quyết định ở `workbenchView.ts` (hàm thuần, có jest); hook chỉ nối dây. Server vẫn tự tính lại kế hoạch + cổng ở POST — `describeHandoffResult` báo `leaks` nếu xuất hiện sau GET.
import { useCallback, useRef, useState } from 'react';
import { message } from 'antd';
import { adaptationApi } from '../../../services/api/adaptation';
import type { HandoffPlanPreview } from '../../../types/adaptationWorkbench';
import { describeAdaptationError, describeHandoffResult, HandoffResultView } from '../adaptationUtils';
import { useWorkbenchCtx } from './WorkbenchContext';
import { handoffClickDecision, handoffNothingText } from './workbenchView';

export interface HandoffClickApi {
  /** Đang GET kế hoạch / POST đẩy (chống bấm đúp — không còn nút `loading` của hộp khi đẩy thẳng). */
  checking: boolean;
  click: () => Promise<void>;
  /** Kế hoạch đang hiện trong hộp (có tên gốc rò); null = hộp đóng. */
  modalPlan: HandoffPlanPreview | null;
  closeModal: () => void;
}

export const useHandoffClick = (): HandoffClickApi => {
  const { storyId, refreshAll, showError } = useWorkbenchCtx();
  const [checking, setChecking] = useState(false);
  const [modalPlan, setModalPlan] = useState<HandoffPlanPreview | null>(null);
  const inflight = useRef(false);

  const click = useCallback(async () => {
    if (inflight.current) return;
    inflight.current = true; setChecking(true);
    try {
      const plan = await adaptationApi.handoffPlan(storyId);
      const d = handoffClickDecision(plan);
      if (d === 'NOTHING') { message.info(handoffNothingText(plan), 6); return; }
      if (d === 'MODAL') { setModalPlan(plan); return; }
      const r = await adaptationApi.handoff(storyId);
      const view = describeHandoffResult(r as unknown as HandoffResultView);
      if (view.level === 'warning') message.warning(view.text, 10); else message.success(view.text, 5);
      await refreshAll();
    } catch (e) {
      showError(describeAdaptationError(e));
    } finally { inflight.current = false; setChecking(false); }
  }, [storyId, refreshAll, showError]);

  return { checking, click, modalPlan, closeModal: useCallback(() => setModalPlan(null), []) };
};
